// extracted by mini-css-extract-plugin
export default {"morePage":"MorePage_morePage__fE+WM","navList":"MorePage_navList__aXzpc"};